// extracted by mini-css-extract-plugin
export default {"regWall":"_NZ3XvWG","mobile":"mobile","controls":"qHA_iZ4Z","control":"wGQsg3d0","desktop":"desktop","title":"Fcy7efsO"};